@for (promo of promotions(); track $index) {
  @if (!closedIndices().has($index)) {
    <div class="annoucement-message layout-container">
      <p-message
        severity="info"
        [closable]="true"
        data-test="global-banner"
        (onClose)="closeBanner($index)"
      >
        <ng-template #closeicon>
          <i class="ph ph-x" aria-hidden="true" style="font-size: 2rem; font-weight: 100"></i>
        </ng-template>
        <span class="message">
          {{ promo?.promotion }}
          @if (promo?.ctaText) {
            <app-button
              class="cta"
              [label]="$safeNavigationMigration(promo?.ctaText)"
              variant="link"
              size="sm"
              (clicked)="ctaButtonClick()"
            />
          }
        </span>
      </p-message>
    </div>
  }
}
